import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVirbComponent } from './simple-icons-virb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVirbComponent ],
    exports:      [ SimpleIconsVirbComponent ],
    bootstrap:    []
})
export class SimpleIconsVirbModule {}
